import { useRouter } from '@u3u/vue-hooks'
import { computed } from '@vue/composition-api'
import { APP_CONFIGS, AppKey } from '@/appConfigs'

// eslint-disable-next-line
export function useApp() {
  const { route } = useRouter()
  const appKeys = Object.keys(APP_CONFIGS)
  const currentAppKey = computed(() => route.value.params['app'] as AppKey)
  const currentApp = computed(
    () => currentAppKey.value && APP_CONFIGS[currentAppKey.value]
  )
  const altApps = computed(() =>
    Object.entries(APP_CONFIGS)
      .filter(([key]) => key !== currentAppKey.value)
      .map(([_, config]) => config)
  )

  return {
    appKeys,
    currentApp,
    altApps
  }
}
